import packageInfo from 'package.json';
import { http } from '../../drivers/data';
import './locales';

http.events.beforeSending((options) => {
  options.headers.platform = 'web';
  options.headers.version = packageInfo.version;
});
